import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=4371ca06&scoped=true&"
import script from "./MessageContent.vue?vue&type=script&lang=js&"
export * from "./MessageContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=4371ca06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4371ca06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4371ca06')) {
      api.createRecord('4371ca06', component.options)
    } else {
      api.reload('4371ca06', component.options)
    }
    module.hot.accept("./MessageContent.vue?vue&type=template&id=4371ca06&scoped=true&", function () {
      api.rerender('4371ca06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/MessageContent.vue"
export default component.exports